import React from 'react';
// Remove TestCategory import as categories are strings
// import { TestCategory } from '@/hooks/use-test-catalog'; 
import { Button } from '@/components/ui/button'; // Use shadcn Button

interface TestCategoryListProps {
  categories: string[]; // Categories are just strings from the hook
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const TestCategoryList: React.FC<TestCategoryListProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  return (
    <nav className="flex flex-col space-y-1">
      <Button 
        variant={selectedCategory === null ? 'secondary' : 'ghost'} 
        size="sm"
        className="w-full justify-start"
        onClick={() => onSelectCategory(null)}
      >
        All Categories
      </Button>
      {categories.map((category) => (
        <Button 
          key={category} // Use category string as key
          variant={selectedCategory === category ? 'secondary' : 'ghost'} 
          size="sm"
          className="w-full justify-start"
          onClick={() => onSelectCategory(category)} // Pass the category string
        >
          {category} {/* Display the category string */}
        </Button>
      ))}
    </nav>
  );
};

export default TestCategoryList; 